var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"capturer",staticClass:"paste-capturer",attrs:{"contenteditable":"true"},on:{"paste":function($event){$event.preventDefault();return _vm.pasteHandler.apply(null, arguments)},"copy":function($event){$event.preventDefault();},"cut":function($event){$event.preventDefault();},"keypress":function($event){$event.preventDefault();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }